import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=47eeee72&lang=html"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=47eeee72&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47eeee72')) {
      api.createRecord('47eeee72', component.options)
    } else {
      api.reload('47eeee72', component.options)
    }
    module.hot.accept("./WangEditor.vue?vue&type=template&id=47eeee72&lang=html", function () {
      api.rerender('47eeee72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/WangEditor.vue"
export default component.exports